import { DownOutlined, SearchOutlined } from "@ant-design/icons";
import { Col, Collapse, Input, Row } from "antd";
import { useState } from "react";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";
import Layout from "../../Components/Layout/Layout";
import { faqData as data } from "./data";
import styles from "./FAQ.module.scss";

// importing images

const FAQ = () => {
    const [activeCategory, setActiveCategory] = useState(1);
    const [faqData, setFaqData] = useState(() => data);
    const active_item_question_length = faqData.find((item) => item.id === activeCategory).questions.length;

    // handle search
    const handleSearch = (e) => {
        const searchQuery = e.target.value;
        const filteredData = faqData.map((item) => {
            return {
                ...item,
                questions: item.questions.filter((question) => {
                    return (
                        question.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
                        question.answer.toLowerCase().includes(searchQuery.toLowerCase())
                    );
                }),
            };
        });

        setFaqData(filteredData);

        if (searchQuery === "") {
            setFaqData(data);
        }
    };

    return (
        <Layout>
            <div className={`${styles.faq_wrap} container`}>
                <BreadCrumb
                    list={[
                        { name: "Home", link: "/" },
                        {
                            name: "Frequently Asked Questions (FAQ)",
                            link: "/faq",
                        },
                    ]}
                />
                <Row>
                    <Col span={24}>
                        <h2 className={styles.headline}>Hello, How can we help?</h2>
                    </Col>
                </Row>
                <Row>
                    <Col
                        xs={24}
                        lg={{
                            span: 12,
                            offset: 6,
                        }}
                    >
                        <Input
                            placeholder="I'm searching for..."
                            size={"large"}
                            prefix={<SearchOutlined />}
                            onChange={(e) => handleSearch(e)}
                            allowClear
                        />
                    </Col>
                </Row>
                <br />
                <Row gutter={[10, 10]}>
                    {faqData.map((item, index) => (
                        <Col xs={8} flex={window.innerWidth > 991 ? "11.11111111%" : null} key={index}>
                            <div
                                className={
                                    activeCategory === item.id
                                        ? `${styles.category_item} ${styles.category_item_active}`
                                        : styles.category_item
                                }
                                onClick={() => setActiveCategory(item.id)}
                                role="button"
                            >
                                <img src={activeCategory === item.id ? item.active_image : item.inactive_image} alt="" />
                                <p> {item.name} </p>
                            </div>
                        </Col>
                    ))}
                </Row>
                <Row>
                    <Col span={24}>
                        <div className={styles.top_q_count}>Top {active_item_question_length} Questions</div>
                    </Col>
                </Row>

                <Row>
                    <div className={styles.questions}>
                        <Collapse
                            accordion={true}
                            ghost={true}
                            expandIcon={({ isActive }) => <DownOutlined size={20} rotate={isActive ? 180 : 0} />}
                            bordered={false}
                            expandIconPosition="end"
                        >
                            {faqData
                                .find((item) => item.id === activeCategory)
                                .questions.map((item) => (
                                    <Collapse.Panel header={<span style={{ marginLeft: 5 }}> {item.question} </span>} key={item.id}>
                                        <span>{item.answer}</span>
                                    </Collapse.Panel>
                                ))}
                        </Collapse>
                        {active_item_question_length === 0 && (
                            <p>Uh-oh!, we could not find any question related to your search. Please try again or contact us.</p>
                        )}
                    </div>
                </Row>
            </div>
        </Layout>
    );
};

export default FAQ;
